import React from 'react';
import { string } from 'prop-types';
import { Hero as HeroComponent } from '@thd-olt-component-react/hero';
import { QueryProvider } from '@thd-nucleus/data-sources';

export function CustomRenderedHero({ id }) {
  return (
    <QueryProvider cacheKey="hero">
      <HeroComponent componentId={id} componentClass="Hero" />
    </QueryProvider>
  );
}

CustomRenderedHero.propTypes = {
  id: string,
};

CustomRenderedHero.defaultProps = {
  id: undefined,
};
